module.exports = __webpack_public_path__ + "img/mw.e6701841.svg";